/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {PopoverDirective} from 'ngx-bootstrap/popover';
import template from './creative-list-filters.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-creative-list-filters',
  template
})
export class CreativeListFiltersComponent implements OnChanges {
  @Input() list: any;
  @Input() calledFrom: string;
  @Input() hasCreativeSet: boolean;

  @ViewChild('layoutFilterPopoverTrigger', {read: PopoverDirective}) layoutFilterPopoverDir: PopoverDirective;
  @ViewChild('lineItemFilterPopoverTrigger', {read: PopoverDirective}) lineItemFilterPopoverDir: PopoverDirective;
  @ViewChild('creativeSetFilterPopoverTrigger', {read: PopoverDirective}) creativeSetFilterPopoverDir: PopoverDirective;

  ngOnChanges(): void {
    if (this.list && !this.list.joinFilterBy) {
      this.list.joinFilterBy = 'Layout';
    }
  }

  applyJoinFilter(): void {
    this.list?.filterOnSelect?.('creative');
    this.layoutFilterPopoverDir?.hide();
    this.lineItemFilterPopoverDir?.hide();
    this.creativeSetFilterPopoverDir?.hide();
  }

  clearJoinFilter(): void {
    this.list?.filterOnSelect?.('creative', true);
  }

  setJoinFilterBy(value: string): void {
    if (this.list) {
      this.list.joinFilterBy = value;
    }
  }

  layoutFilterActive(): boolean {
    return !!this.list?.joinMessage && this.list?.savedFilterBy === 'Layout';
  }

  lineItemFilterActive(): boolean {
    return !!this.list?.joinMessage && this.list?.savedFilterBy === 'LineItem';
  }

  creativeSetFilterActive(): boolean {
    return !!this.list?.joinMessage && this.list?.savedFilterBy === 'CreativeSet';
  }
}
